import React from 'react';
import ReactGA from 'react-ga4';

const Content = () => {
  return (
    <>
      <div className="popup-content-title">
        <h3>Officer South - Cardinia Road Employment Precinct (CREP)</h3>
      </div>
      <div className="popup-content-source">
        <p className="bold">
        We’re upgrading the sewer pipeline and pump station in the Officer South area, to increase the capacity of the network and cater for population growth.
        </p>
        <p>
        This project will upgrade an existing interim gravity sewer and sewer rising main, as well as install a new pump station to help manage the 
        increase in flows to the Cardinia Road Employment Precinct (CREP) area. 
        </p>
        <p>
        Our Industry Partner Beca, Fulton Hogan, 
      Interflow Joint venture (BFHI) will mobilise to site in October 2026. We expect to finish construction by the end of 2027.
        </p>
        <p>
          For more information click{' '}
          <a
            href="https://southeastwater.com.au/faults-and-works/works/planned-works/officer-south-cardinia-road-employment-precinct-sewer-upgrade/"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: `Map – Water Renewals (blue)`,
                action: '<a href> link',
                label:
                  'MORE INFO: Officer South - Cardinia Road Employment Precinct (CREP)',
              });
            }}
          >
            here
          </a>{' '}
          or contact the project team at{' '}
          <a href="tel:1800403777">1800 403 777</a> |{' '}
          <a
            href="mailto:engagement@sew.com.au"
            target="_blank"
            rel="noreferrer"
            onClick={() => {
              ReactGA.event({
                category: `Map - Water Renewals (blue)`,
                action: 'Email link',
                label:
                  'MAIL TO: engagement@sew.com.au: Officer South - Cardinia Road Employment Precinct (CREP)',
              });
            }}
          >
            engagement@sew.com.au
          </a>
        </p>
      </div>
    </>
  );
};

export default Content;
